// GlobalAuthModal.tsx - Global auth modal that can be triggered from anywhere
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthModal } from '../context/AuthModalContext';
import AuthModal from './AuthModal';

const GlobalAuthModal: React.FC = () => {
  const { isOpen, mode, isRequestingContext, closeModal } = useAuthModal();
  const navigate = useNavigate();

  const handleClose = (successfulLogin: boolean = false) => {
    closeModal();
    if (successfulLogin && !isRequestingContext) {
      // Only redirect to dashboard if NOT in request flow
      // Request flow will handle its own redirect
      navigate('/dashboard');
    }
  };

  return (
    <AuthModal
      open={isOpen}
      onClose={handleClose}
      mode={mode}
      isRequestingContext={isRequestingContext}
    />
  );
};

export default GlobalAuthModal;
